import BusinessIndex from "../business/screens/BusinessIndex"


const rootPath = 'business'
export const businessRoutes = [
    {
        path: rootPath,
        element: <BusinessIndex />,
        isProtected: true
    },
]